module.exports = __webpack_public_path__ + "static/media/thumb1.bceca505.png";